import { useEffect, useState } from "react"

import {
  POLL_INTERVAL_MS,
  fetchLatestBuildId,
  isNewVersionAvailable
} from "../utils/version-check/version-check.ts"

// Once true this never goes back to false on its own — a later poll cannot
// un-observe a build that was already seen live, and the banner's own
// dismiss is a separate, session-only concern the caller owns.
export const useNewVersionAvailable = (): boolean => {
  const [available, setAvailable] = useState(false)

  useEffect(() => {
    let cancelled = false

    const poll = async () => {
      const latest = await fetchLatestBuildId()
      if (!cancelled && isNewVersionAvailable(latest)) {
        setAvailable(true)
      }
    }

    const timer = window.setInterval(poll, POLL_INTERVAL_MS)

    // A tab backgrounded across a deploy would otherwise wait out the full
    // interval after being reopened before it ever checks again.
    const onVisible = () => {
      if (document.visibilityState === "visible") void poll()
    }
    document.addEventListener("visibilitychange", onVisible)

    return () => {
      cancelled = true
      window.clearInterval(timer)
      document.removeEventListener("visibilitychange", onVisible)
    }
  }, [])

  return available
}
